import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { queryClient } from 'configs/queryClient';
import useB2CServiceHistoryRequestQuery from 'hooks/useB2CServiceHistoryRequestQuery';

async function uploadB2CFile(apiClient: ApiClient, id: number, file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.POST('/op/v2/b2c-service-history-request/{id}/confirmation', {
    params: { path: { id } },
    // @ts-expect-error Body is not documented as FormData in the OpenAPI spec
    body: formData,
    headers: {
      Accept: 'application/json',
      'Content-Type': null,
    },
  });
}

export default function useUploadB2CFileMutation(id: number) {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: (data: { file: { file: File } }) => throwOnError(uploadB2CFile(apiClient, id, data.file.file)),
    mutationKey: ['UploadB2CFile', id],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useB2CServiceHistoryRequestQuery.getKey(id) });
    },
  });
}
